import { EnjoyedYearDto } from '@app/data/dtos/ptrab/irs/enjoyed-year.dto';
import {
  IrsDependentDto,
  IrsDto,
  IrsSpouseDto,
  IrsWithholdingDto,
  IrsWithholdingVoluntaryDto,
  IrsWorkerPersonalDataDto,
  IrsYoungBenefitDto
} from '@app/data/dtos/ptrab/irs/irs.dto';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { EnjoyedYear } from '@app/entities/models/ptrab/irs/enjoyed-year.model';
import {
  Dependant,
  IrsModel,
  IrsWithholdingModel,
  Spouse,
  WorkerPt,
  YoungBenefit
} from '@app/entities/models/ptrab/irs/irs.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapIrs: MapFromFn<IrsDto, IrsModel> = (value) =>
  Builder.forModel(IrsModel)
    .worker(mapWorkerPt(value.worker))
    .spouse(mapSpouse(value.spouse))
    .dependants(mapDependantData(value.dependents))
    .youngBenefit(mapYoungBenefit(value.irs_jovem))
    .build();

export const mapDataIrs: MapFromFn<IDataResponse<IrsDto>, IrsModel> = (value) => mapIrs(value.data);

export const mapIrsWithholding: MapFromFn<IrsWithholdingDto, IrsWithholdingModel> = (value) =>
  Builder.forModel(IrsWithholdingModel)
    .maxRetention(value.max_retention)
    .multiplyFactor(value.multiply_factor)
    .voluntaryRetention(value.voluntary_retention)
    .build();

export const mapDataIrsWithholding: MapFromFn<IDataResponse<IrsWithholdingDto>, IrsWithholdingModel> = (value) =>
  mapIrsWithholding(value.data);

export const mapIrsVoluntaryWithholding: MapFromFn<number, IrsWithholdingVoluntaryDto> = (value) =>
  Builder.forDto<IrsWithholdingVoluntaryDto>().voluntary_retention(value).build();

export const mapIrsWithholdingDto: MapFromFn<IrsWithholdingModel, IrsWithholdingDto> = (value) =>
  Builder.forDto<IrsWithholdingDto>()
    .max_retention(value.maxRetention)
    .multiply_factor(value.multiplyFactor)
    .voluntary_retention(value.voluntaryRetention)
    .build();

export const mapWorkerPt: MapFromFn<IrsWorkerPersonalDataDto, WorkerPt> = (value) =>
  Builder.forModel(WorkerPt)
    .civilStatusId(value.civil_status)
    .civilStatusName(value.civil_status_name)
    .disability(value.disability_type)
    .percentage(value.disability_percentage)
    .fiscalStatus(value.fiscal_status)
    .incomeTitularity(value.income_titularity)
    .build();

export const mapWorkerDto: MapFromFn<WorkerPt, IrsWorkerPersonalDataDto> = (value) =>
  Builder.forDto<IrsWorkerPersonalDataDto>()
    .civil_status(value.civilStatusId)
    .civil_status_name(value.civilStatusName)
    .disability_type(Number(value.disability))
    .disability_percentage(Number(value.percentage))
    .fiscal_status(value.fiscalStatus)
    .income_titularity(value.incomeTitularity)
    .build();

export const mapSpouse: MapFromFn<IrsSpouseDto, Spouse> = (value) =>
  Builder.forModel(Spouse).disability(value.disability_type).percentage(value.disability_percentage).build();

export const mapSpouseDto: MapFromFn<Spouse, IrsSpouseDto> = (value) =>
  Builder.forDto<IrsSpouseDto>()
    .disability_type(Number(value.disability))
    .disability_percentage(Number(value.percentage))
    .build();

export const mapDependant: MapFromFn<IrsDependentDto, Dependant> = (value) =>
  Builder.forModel(Dependant)
    .id(value.id)
    .birthdate(value.birth_date)
    .disability(value.disability_type)
    .percentage(value.disability_percentage)
    .build();

export const mapDependantDto: MapFromFn<Dependant, IrsDependentDto> = (value) =>
  Builder.forDto<IrsDependentDto>()
    .id(value.id)
    .birth_date(value.birthdate)
    .disability_type(Number(value.disability))
    .disability_percentage(Number(value.percentage))
    .build();

export const mapDependantData: MapFromFn<IrsDependentDto[], Dependant[]> = (value) => value.map(mapDependant);

export const mapYoungBenefit: MapFromFn<IrsYoungBenefitDto, YoungBenefit> = (value) =>
  Builder.forModel(YoungBenefit).years(value.benefit_years).build();

export const mapYoungBenefitDto: MapFromFn<YoungBenefit, IrsYoungBenefitDto> = (value) =>
  Builder.forDto<IrsYoungBenefitDto>().benefit_years(value.years).build();

export const mapEnjoyedYear: MapFromFn<EnjoyedYearDto, EnjoyedYear> = (value) =>
  Builder.forModel(EnjoyedYear).id(value.id).name(value.name).build();

export const mapDataEnjoyedYear: MapFromFn<IDataResponse<EnjoyedYearDto[]>, EnjoyedYear[]> = (value) =>
  value.data.map(mapEnjoyedYear);
